// eslint-disable-next-line
import PropTypes from 'prop-types'

/**
 * @typedef TNotyItem
 * @property {number} id
 * @property {string} content
 * @property {string} group
 * @property {TNotyItemOptions} opts
 * @property {STATUS_ERROR | STATUS_MESSAGE | STATUS_SUCCESS | STATUS_WARNING } status
 */

/**
 * @typedef TNotyButton
 * @property {string} label
 * @property {function} onClick
 */

/**
 * @typedef TNotyItemOptions
 * @property {number} timeout
 * @property {string} icon
 * @property {TNotyButton} primaryButtonProps
 * @property {TNotyButton} dangerButtonProps
 */

/**
 * @typedef TNotyConfirm
 * @property {boolean} isVisible
 * @property {string} title
 * @property {boolean} danger
 * @property {ReactElement} body
 * @property {string} primaryButtonText
 * @property {string} secondaryButtonText
 */

/**
 * @typedef TNotyState
 * @property {Array.<TNotyItem>} notys
 * @property {TNotyConfirm} confirm
 */

/** */
export const STATUS_CONFIRM = 'confirm'
export const STATUS_ERROR = 'error'
export const STATUS_MESSAGE = 'message'
export const STATUS_SUCCESS = 'success'
export const STATUS_WARNING = 'warning'

export const ItemShape = {
  id: PropTypes.number,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  status: PropTypes.oneOf([
    STATUS_ERROR,
    STATUS_MESSAGE,
    STATUS_SUCCESS,
    STATUS_WARNING,
  ]),
  opts: PropTypes.shape({
    timeout: PropTypes.number,
    icon: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
  }),
  group: PropTypes.string,
}
